import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess2013Status: 'idle',
    startProcess2013Error: undefined as any,
    loadUserParamsProcess2013Status: 'idle',
    loadUserParamsProcess2013Error: undefined as any,

    process2013List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess2013 = createAsyncThunk('process2013Slice/startProcess2013', async ({ process2013 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess2013/`,
        prepareData(process2013),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess2013Status } = getState().process2013Slice
        return startProcess2013Status !== 'pending'
    }
})

export const loadUserParamsProcess2013 = createAsyncThunk('process2013Slice/loadUserParamsProcess2013', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess2013/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess2013Status } = getState().process2013Slice
        return loadUserParamsProcess2013Status !== 'pending'
    }
})

const Process2013Slice = createSlice({
    name: 'process2013Slice',
    initialState,
    reducers: {
        resetstartProcess2013: (state) => {
            state.job = undefined
            state.startProcess2013Error = undefined
        },
        resetstartProcess2013Error: (state) => {
            state.startProcess2013Error = undefined
        },
        resetloadUserParamsProcess2013: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess2013Error = undefined
        },
        resetloadUserParamsProcess2013Error: (state) => {
            state.loadUserParamsProcess2013Error = undefined
        },
        removeFromProcess2013ListById: (state, action) => {
            state.process2013List = state.process2013List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess2013ListByIds: (state, action) => {
            state.process2013List = state.process2013List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process2013List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess2013Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process2013List = []
            state.startProcess2013Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess2013.pending, (state) => {
            state.startProcess2013Status = 'pending'
            state.startProcess2013Error = undefined
        })
        builder.addCase(startProcess2013.fulfilled, (state, action) => {
            state.startProcess2013Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess2013.rejected, (state, action) => {
            state.startProcess2013Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess2013Error = action.error.message
            } else {
                state.startProcess2013Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess2013.pending, (state) => {
            state.loadUserParamsProcess2013Status = 'pending'
            state.loadUserParamsProcess2013Error = undefined
        })
        builder.addCase(loadUserParamsProcess2013.fulfilled, (state, action) => {
            state.loadUserParamsProcess2013Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess2013.rejected, (state, action) => {
            state.loadUserParamsProcess2013Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess2013Error = action.error.message
            } else {
                state.loadUserParamsProcess2013Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess2013,
    resetstartProcess2013Error,
    resetloadUserParamsProcess2013,
    resetloadUserParamsProcess2013Error,
    removeFromProcess2013ListById,
    removeFromProcess2013ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process2013Slice.actions
export default Process2013Slice.reducer
